import React, { FC } from 'react';
import cx from 'classnames';

import useThemeBlock from '@/hooks/useThemeBlock';
import { CardLinkProps } from '@/helpers/CardControls/typings';
import { Link } from '@/helpers/Link/render';
import { Image } from '@/components/molecules/Image/render';

import block from './block.json';
import { getStyles } from './styles.css';

/**
 * TYPINGS
 */
type CardPeopleProps = ThemeProps & {
	image: ImageProps;
	name: string;
	role: string;
	link?: CardLinkProps;
};

/**
 * COMPONENT
 */
export const CardPeople: FC<CardPeopleProps> & BlockConfigs = ({
	image,
	name,
	role,
	link: {
		href = null,
		title = null,
		opensInNewTab = false,
		...linkProps
	} = {},
	theme = {},
}) => {
	const { variant, blockTheme } = useThemeBlock(block.slug, theme);

	const rootClass = cx(
		'supt-card supt-cardPeople',
		getStyles(blockTheme),
		href && title && 'supt-isClickAreaExpanded'
	);

	return (
		<div
			className={rootClass}
			data-block={block.slug}
			data-variant={variant}
		>
			<div className="supt-cardPeople__image">
				{image?.src && (
					<Image {...image} alt={image.alt || name} layout="fill" />
				)}
			</div>

			<div className="supt-cardPeople__content">
				<h3
					className="supt-cardPeople__name"
					dangerouslySetInnerHTML={{ __html: name }}
				/>
				<p
					className="supt-cardPeople__role"
					dangerouslySetInnerHTML={{ __html: role }}
				/>
				{href && title ? (
					<div className="supt-cardPeople__blocks">
						<Link
							href={href}
							{...(opensInNewTab && {
								target: '_blank',
								rel: 'noopener noreferrer',
							})}
							{...linkProps}
						>
							{title}
						</Link>
					</div>
				) : null}
			</div>
		</div>
	);
};

CardPeople.slug = block.slug;
CardPeople.title = block.title;
